export const SERVICE_PATH = "https://api.unlockideas.com";